module.exports = __webpack_public_path__ + "img/image_core03@2x.400545fa.png";